import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getAllWarehouses } from 'reducers/warehouses';
import { Product } from 'types/Product';

const useStyles = makeStyles(() => ({
  subTableContainer: {
    padding: '0 0 0 1.5rem !important',
    '& tr:last-child > td': {
      borderBottom: 0,
    },
  },
}));

interface Props {
  productInWarehouse: Product['warehouses'];
}

function StockTableMobile({ productInWarehouse }: Props) {
  const { t } = useTranslation('product');
  const styles = useStyles();
  const warehouses = useSelector(getAllWarehouses);
  return (
    <Table size="small" stickyHeader>
      {warehouses.map(warehouse => {
        const stock = productInWarehouse?.[`${warehouse.warehouseID}`];
        const asNumber = a => (a !== undefined ? Number(a) : '?');
        return (
          <>
            <TableHead>
              <TableRow>
                <TableCell data-testid="warehouse-name">
                  {warehouse.name}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                data-testid="stock-row"
                key={`stockIn${warehouse.warehouseID}`}
              >
                <TableCell className={styles.subTableContainer}>
                  <Table size="small" stickyHeader>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          {t('relatedProducts.headers.stockInfo.total')}
                        </TableCell>
                        <TableCell data-testid="total-stock" align="right">
                          {asNumber(stock?.totalInStock)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          {t('relatedProducts.headers.stockInfo.reserved')}
                        </TableCell>
                        <TableCell data-testid="reserver" align="right">
                          {asNumber(stock?.reserved)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          {t('relatedProducts.headers.stockInfo.free')}
                        </TableCell>
                        <TableCell data-testid="free" align="right">
                          {asNumber(stock?.free)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableCell>
              </TableRow>
            </TableBody>
          </>
        );
      })}
    </Table>
  );
}

export default StockTableMobile;
